import {
  type DocumentData,
  serverTimestamp,
  type Timestamp,
} from "firebase/firestore";
import { makeObservable, observable } from "mobx";
import type { Api } from "./apis";
import type { Stores } from "./stores";

export interface BaseModelData {
  uid: string;
  archived?: boolean;
  ts?: Timestamp;
  isDraggable?: boolean;
  isExpandable?: boolean;
}

export class BaseModel<T extends BaseModelData> {
  @observable readonly data: T;

  constructor(
    protected stores: Stores,
    protected api: Api,
    data: T,
  ) {
    this.data = data;

    makeObservable(this);
  }

  get uid() {
    return this.data.uid;
  }

  set uid(newUid) {
    this.data.uid = newUid;
  }

  addEmailReminders(
    planUid: string,
    planName: string,
    moduleUid: string,
    eventDate: Timestamp | null,
  ) {
    this.api.emailRemindersApi.create(moduleUid, {
      createdAt: serverTimestamp() as Timestamp,
      moduleUid,
      eventDate,
      isProcessed: false,
      planUid,
      planName,
    });
  }

  fromBaseModel(): Omit<BaseModelData, "uid"> {
    const data: Omit<BaseModelData, "uid"> = {};

    if (this.data.ts) {
      data.ts = this.data.ts;
    } else {
      data.ts = serverTimestamp() as Timestamp;
    }

    if (this.data.archived) {
      data.archived = true;
    }

    if (this.data.isDraggable !== undefined) {
      data.isDraggable = this.data.isDraggable;
    }

    if (this.data.isExpandable !== undefined) {
      data.isExpandable = this.data.isExpandable;
    }

    return data;
  }

  toFireStore(): DocumentData {
    throw Error("toFireStore no implemented");
  }
}
